const INCOMPATIBLE_BROWSERS = {
  IE: 'ie'
}

export { INCOMPATIBLE_BROWSERS }
